import {Record} from 'immutable';
import {handleActions} from 'redux-actions';

import MealActions from 'web-app/react/entities/meals/meal-plan/action-types';

interface State {
    loadingMealTypes: boolean;
}

class MealTypeState extends Record<State>({
    loadingMealTypes: false,
}) {}

export default handleActions(
    {
        [MealActions.MEAL_TYPE_FETCH]: state =>
            state.merge({
                loadingMealTypes: true,
            }),
        [MealActions.MEAL_TYPE_FETCH_SUCCESS]: state =>
            state.merge({
                loadingMealTypes: false,
            }),
        [MealActions.MEAL_TYPE_UPDATE]: state =>
            state.merge({
                loadingMealTypes: true,
            }),
        [MealActions.MEAL_TYPE_UPDATE_SUCCESS]: state =>
            state.merge({
                loadingMealTypes: false,
            }),
    },
    new MealTypeState(),
);
